import React from "react";
import PropTypes from "prop-types";

const InlineSpinner = () => (
    <span className="spinner-border spinner-border-sm hms-inline-spinner" role="status" aria-hidden="true" />
);

export const ActionButton = ({
    as: Component = "button",
    children,
    className = "",
    icon,
    loading = false,
    disabled = false,
    type = "button",
    variant = "primary",
    size = "default",
    ...props
}) => {
    const classes = [
        "btn",
        "hms-button",
        `hms-button--${variant}`,
        size === "compact" ? "hms-button--compact" : "",
        className,
    ].filter(Boolean).join(" ");

    const componentProps = {
        className: classes,
        "aria-busy": loading || undefined,
        ...props,
    };

    if (Component === "button") {
        componentProps.type = type;
        componentProps.disabled = disabled || loading;
    }

    if ((disabled || loading) && Component !== "button") {
        componentProps["aria-disabled"] = true;
        componentProps.tabIndex = -1;
    }

    return (
        <Component {...componentProps}>
            {loading ? <InlineSpinner /> : icon}
            {children ? <span>{children}</span> : null}
        </Component>
    );
};

ActionButton.propTypes = {
    as: PropTypes.elementType,
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.node,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    variant: PropTypes.oneOf(["primary", "secondary", "outline", "danger", "warning", "info"]),
    size: PropTypes.oneOf(["default", "compact"]),
};
